// extracted by mini-css-extract-plugin
export default {"modalTitle":"DeleteModal_modalTitle__Ft3mE","modalContent":"DeleteModal_modalContent__guy8q"};